<template>
  <div class="sri-smi-page">
    <action-header
      v-if="!hasValidRole(role, [Role.Student, Role.Family])"
      :button="buttonSearch"
      :data.sync="studentValue"
      @studentValue="studentValue = $event"
      @export-pdf="exportPdf()"
      :show-export="showExport"
      ref="actionHeader"
    ></action-header>
    <div v-else class="md-layout hidden lg:block">
      <div class="md-layout-item text-right">
        <md-button
          class="md-warning"
          @click.prevent="exportPdf()"
          v-if="showExport"
        >
          {{ $t("common.export") }}
        </md-button>
      </div>
    </div>

    <div v-if="data.user">
      <general-assessment :data="data.user"></general-assessment>
      <assessment-detail
        :data-detail="data.sriDetail"
        :title="$t('smi_sri.sri_detail')"
        type="SRI"
      ></assessment-detail>
      <assessment-detail
        :data-detail="data.smiDetail"
        :title="$t('smi_sri.smi_detail')"
        type="SMI"
      ></assessment-detail>

      <div v-if="showExport">
        <pdf-default ref="pdfContent" pdf-format="letter">
          <template #pdf-content>
            <export-pdf-sri-smi
              :info="data.user"
              :chart-sri="data.sriDetail"
              :chart-smi="data.smiDetail"
            ></export-pdf-sri-smi>
          </template>
        </pdf-default>
      </div>
    </div>
    <div class="md-layout" v-else>
      <div class="md-layout-item md-empty-page">
        <student-image class="student-image w-full"></student-image>
        <div>
          <h2 class="font-bold text-2xl">
            {{ $t("smi_sri.get_assessment") }}
          </h2>
          <p>
            {{ $t("smi_sri.please_select_the_student") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionHeader from "./DetailPage/ActionHeader";
import StudentImage from "@/components/Base/Illustration/Student";
import { service_paths } from "@/constants/Services";
import AssessmentDetail from "./DetailPage/AssessmentDetail";
import GeneralAssessment from "../Components/General";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";
import { mapGetters, mapState } from "vuex";
import { getId, Message } from "@/helpers/utils";
import ExportPdfSriSmi from "./DetailPage/ExportPdfSriSmi";
import PdfDefault from "../../../components/PdfDefault";
import moment from "moment";

export default {
  components: {
    PdfDefault,
    ExportPdfSriSmi,
    GeneralAssessment,
    AssessmentDetail,
    ActionHeader,
    StudentImage
  },
  data() {
    return {
      buttonSearch: {
        title: "common.search",
        action: this.searchStudent
      },
      data: {},
      studentValue: null,
      hasValidRole,
      Role,
      showExport: false
    };
  },
  watch: {
    studentValue() {
      this.data = {};
      this.showExport = false;
    }
  },
  computed: {
    ...mapState("user", ["info"]),
    ...mapState("switchAccountChild", ["currentChild"]),
    ...mapGetters("user", ["role"])
  },
  created() {
    if (hasValidRole(this.role, Role.Student)) {
      this.studentValue = getId(this.info);
      this.searchStudent();
    }

    if (hasValidRole(this.role, Role.Family)) {
      this.studentValue = getId(this.currentChild);
      this.searchStudent();
    }

    const query = this.$route.query;
    if (!hasValidRole(this.role, Role.Student) && query.tabName === "SRI_SMI") {
      this.setInfoStudentByQuery(query);
    }
  },
  methods: {
    setInfoStudentByQuery(query) {
      this.studentValue = query.id;
      this.searchStudent();
      this.$router.replace({ query: {} });
    },
    searchStudent() {
      if (!this.studentValue) {
        Message.error(
          this.$t("smi_sri.please_select_the_student_to_view_report")
        );
        return;
      }
      this.$axios
        .get(`${service_paths.sri_smi}/assessment/user/${this.studentValue}`)
        .then(response => {
          this.data = Object.assign({}, response.data);
          if (!hasValidRole(this.role, [Role.Student, Role.Family])) {
            this.$refs.actionHeader.studentData.displayValue =
              this.data.user?.full_name +
                " - " +
                this.data.user?.student_code || "";
          }
          this.data.sriDetail = this.addOrdinalColumn(
            response.data.sri_detail.flat()
          );
          this.data.smiDetail = this.addOrdinalColumn(
            response.data.smi_detail.flat()
          );
          this.showExport =
            !!this.data.sri_detail.length || !!this.data.smi_detail.length;
        });
    },
    addOrdinalColumn(tableData) {
      if (!tableData) return tableData;

      return tableData.map((record, idx) => ({
        ...record,
        noNumb: idx + 1,
        score: record.lexile_scores || record.quantile_scores,
        date: this.convertDateByLanguage(record.date)
      }));
    },
    convertDateByLanguage(dateTime) {
      const formatDateClient =
        localStorage.getItem("language") === "en"
          ? "MM-DD-YYYY HH:mm:ss"
          : "DD-MM-YYYY HH:mm:ss";
      return moment(dateTime).format(formatDateClient);
    },
    exportPdf() {
      this.$refs.pdfContent.generatePdf();
    }
  }
};
</script>

<style lang="scss" scoped>
.sri-smi-page {
  &__header {
    margin-bottom: 30px;

    .page-title {
      font-size: 1.5rem;
      color: #1b1f22;
      font-weight: 500;

      span {
        display: inline-block;
        margin-left: 15px;
      }
    }
  }
}

.md-empty-page {
  text-align: center;
  width: 100%;
  .student-image {
    border: none;
    display: inline-block;
  }
}
</style>
